import { render, staticRenderFns } from "./MmHome.vue?vue&type=template&id=b6efe496&scoped=true&"
import script from "./MmHome.vue?vue&type=script&lang=js&"
export * from "./MmHome.vue?vue&type=script&lang=js&"
import style0 from "./MmHome.vue?vue&type=style&index=0&id=b6efe496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6efe496",
  null
  
)

export default component.exports